export default "/assets/images/column-image10.558a6335ddcb1782.webp";